const selectors = {
  videoTemplate: '[data-video-template]',
};

const classes = {
  loading: 'is-loading',
};

const attributes = {
  videoId: 'data-video-id',
};

class VideoBackground extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.videoId = this.getAttribute(attributes.videoId);
    this.videoTemplate = this.querySelector(selectors.videoTemplate);
    this.video = null;

    if (this.videoId) {
      // Force video autoplay on iOS when Low Power Mode is On
      this.addEventListener(
        'touchstart',
        () => {
          this.video?.play();
        },
        {passive: true}
      );

      this.renderVideo();
    }
  }

  renderVideo() {
    /*
      Observe video element and pull it out from its template tag
    */
    this.videoTemplateObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const content = this.videoTemplate.innerHTML;

            this.innerHTML = content;
            this.classList.remove(classes.loading);
            this.video = this.querySelector('video');
            this.observeVideoPlayToggle();

            // Stop observing element after it was animated
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    );

    this.videoTemplateObserver.observe(this);
  }

  observeVideoPlayToggle() {
    if (!this.video) return;

    const options = {
      rootMargin: '0px',
      threshold: [0, 1.0],
    };

    this.videoPlayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting;
        if (isVisible && typeof this.video.play === 'function') {
          this.video.play();
        }
        if (!isVisible && typeof this.video.pause === 'function') {
          this.video.pause();
        }
      });
    }, options);

    this.videoPlayObserver.observe(this.video);
  }

  disconnectedCallback() {
    if (this.videoTemplateObserver) {
      this.videoTemplateObserver.disconnect();
    }

    if (this.videoPlayObserver) {
      this.videoPlayObserver.disconnect();
    }
  }
}

export {VideoBackground};
